.swatch {
    height: 100%;
    width: 100%;
    cursor: pointer;
    position: relative;
    outline: none;
}
